import { useTranslation } from 'react-i18next'

import { ProfileCreatedWidget } from '../../../Widget'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

function RequestProfileWidgetCreated({ isSkeleton, requestData }) {
  const { t } = useTranslation()

  const permissions = requestData?.permissions

  return (
    <ProfileCreatedWidget
      contentProps={{
        ...requestData,
        canViewCreatedBy: permissions?.can_view_created_by,
        canViewUpdatedBy: permissions?.can_view_updated_by,
      }}
      isSkeleton={isSkeleton}
      title={t('Widget.CreatedTitleKey')}
      widgetProps={{
        initiallyExpanded: false,
        qaName: RequestProfileWidgetKey.CREATED,
      }}
    />
  )
}

export default RequestProfileWidgetCreated
